!(function () {
  "use strict";
  if (!customElements.get("related-products")) {
    customElements.define(
      "related-products",
      class extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.loadRelatedProducts();
          this.loadRecentlyViewedProducts();
        }

        loadRelatedProducts() {
          this.relatedProducts = this.querySelector("[data-related-products]");
          if (!this.relatedProducts) return;

          const sectionId = this.getAttribute("data-section-id"),
            productId = this.getAttribute("data-product-id"),
            limit = this.getAttribute("data-limit"),
            url = `${theme.routes.product_recommendations_url}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;

          fetch(url)
            .then((res) => {
              if (!res.ok) {
                this.hideRelated();
                throw new Error(res.status);
              }
              return res.text();
            })
            .then((html) => {
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = html;
              const related = tempDiv.querySelector("[data-related-products]");
              if (related && related.querySelectorAll("[data-product-block]").length) {
                this.relatedProducts.innerHTML = related.innerHTML;
                this.initRelatedSwiper(sectionId);
              }
            })
            .catch((err) => console.error("Error loading related products:", err));
        }

        initRelatedSwiper(sectionId) {
          const section = document.querySelector(`[data-section-id="${sectionId}"]`);
          if (!section) return;

          const desktopPerView = Number(section.dataset.desktopperview || 1);
          const mobilePerView = Number(section.dataset.mobileperview || 1);
          const desktopEnable = String(section.dataset.desktopsliderenable).toLowerCase() === "true";
          const mobileEnable = String(section.dataset.mobilesliderenable).toLowerCase() === "true";

          const containerSel = `.related-product-${sectionId}`;
          const containerEl = section.querySelector(containerSel);
          const nextEl = section.querySelector(".swiper-button-next");
          const prevEl = section.querySelector(".swiper-button-prev");
          const paginationEl = section.querySelector(".swiper-pagination");

          let swiper = null;

          const cfg = {
            spaceBetween: 5,
            slidesPerView: mobilePerView,
            breakpoints: {
              0: { 
                slidesPerView: mobilePerView,
                spaceBetween: 5,
               },
              769: { 
                slidesPerView: desktopPerView,
                spaceBetween: 20,
               },
            },
            pagination: { el: paginationEl, clickable: true },
            navigation: { nextEl, prevEl },
          };

          const showControls = (show) => {
            [nextEl, prevEl, paginationEl].forEach((el) => {
              if (el) el.style.display = show ? "" : "none";
            });
          };

          const updateSwiper = () => {
            const isDesktop = window.innerWidth >= 769;
            const shouldEnable = isDesktop ? desktopEnable : mobileEnable;

            if (shouldEnable) {
              if (!swiper || swiper.destroyed) swiper = new Swiper(containerEl, cfg);
              showControls(true);
            } else {
              if (swiper && !swiper.destroyed) {
                swiper.destroy(true, true);
                swiper = null;
              }
              showControls(false);
            }
          };

          updateSwiper();

          let rAF;
          window.addEventListener("resize", () => {
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(updateSwiper);
          });
        }

        loadRecentlyViewedProducts() {
          this.recentlyViewed = this.querySelector("recently-viewed");
          if (this.recentlyViewed) {
            this.recentlyViewed.addEventListener("theme:recently-viewed:loaded", () => {
              this.handleRecentlyViewedResponse();
            });
          }
        }

        handleRecentlyViewedResponse() {
          const wrapper = this.recentlyViewed.closest("[data-recently-viewed-wrapper]");
          const products = this.recentlyViewed.querySelectorAll("[data-product-block]");
          const aosEls = this.recentlyViewed.querySelectorAll("[data-aos]");
          const gridSlider = this.recentlyViewed.querySelector("grid-slider");
          const min = this.recentlyViewed.hasAttribute("data-minimum")
            ? parseInt(this.recentlyViewed.getAttribute("data-minimum"))
            : 1;
          const isVisible = (!wrapper && products.length > 0) || (wrapper && products.length >= min);
          const mobileCols = gridSlider?.getAttribute("data-column-mobile");

          if (isVisible) {
            if (wrapper && products.length >= min) this.classList.remove("hidden");
            if (gridSlider) {
              requestAnimationFrame(() => {
                gridSlider.dispatchEvent(new CustomEvent("theme:slider:resize", { bubbles: true }));
              });
              gridSlider.querySelectorAll("[data-slide]").forEach((el) => {
                if (mobileCols == 2) {
                  el.classList.add("mobile--one-half");
                  el.classList.remove("mobile--one-whole");
                } else {
                  el.classList.add("mobile--one-whole");
                  el.classList.remove("mobile--one-half");
                }
              });
            }

            let animated = [];
            this.recentlyViewed.addEventListener("theme:target:animate", (evt) => {
              animated.push(evt.detail);
              if (animated.length === aosEls.length) {
                requestAnimationFrame(() =>
                  aosEls.forEach((el) => el.classList.add("aos-animate"))
                );
              }
            });
          }
        }

        hideRelated() {
          const tab = this.relatedProducts.closest("[data-tab]");
          const tabsHolder = this.relatedProducts.closest("[data-tabs-holder]");
          const tabLink = tabsHolder?.querySelector(`[data-tabs-link="${tab?.dataset.tab}"]`);
          if (tab) tab.remove();
          if (tabLink) {
            tabLink.remove();
            tabsHolder?.querySelector("[data-tabs-link]")?.dispatchEvent(new Event("click"));
          }
        }
      }
    );
  }
})();
